import React, { useContext } from 'react'
import { Modal, Button } from 'react-bootstrap'
import * as dayjs from 'dayjs'
import { Formik, Field, Form, getIn } from 'formik'
import * as Yup from 'yup'
import { AuthContext } from '../AuthContext'
import axios from 'axios'
// import DatePicker from 'react-datepicker'
// import 'react-datepicker/dist/react-datepicker.css'

const MetabolicPlanClosed = ({
  caseClosedModalShow,
  setCaseClosedModalShow,
  currentPatient,
  setCaseModalShow,
  setWarning,
}) => {
  const today = dayjs().format('YYYY-MM-DD')

  const initialValues = { finish_type: '' }
  // error classname
  function getClassName(errors, touched, fieldName) {
    const isError = getIn(errors, fieldName) && getIn(touched, fieldName)
    return isError ? 'border border-danger border-2' : ''
  }

  // error message
  function renderErrorMessage(errors, touched, fieldName) {
    const isError = getIn(errors, fieldName) && getIn(touched, fieldName)
    const errorMessage = getIn(errors, fieldName)
    return isError ? <div className="error-message">{errorMessage}</div> : null
  }
  const finishTrack = '/api/crm/project/track/finishTrack'
  const { baseUrl, sendDiscordNotification, currentUser, extendCookie } =
    useContext(AuthContext)
  const handleSubmit = (values) => {
    console.log('values', values)
    const requestBody = {
      project_id: 'P0001',
      patient_id: currentPatient.patient_id,
      clinic_id: currentUser.clinic_id,
      finish_type: Number(values.finish_type),
      finish_time: today,
    }
    console.log('finishTrack requestBody', requestBody)

    setWarning({
      show: true,
      msg: '請再次確保表單內容資料正確，送出後無法修改！',
      confirmMsg: '確認結案',
      onConfirm: () => {
        // TODO 等待 POST 成功後再秀成功訊息
        if (currentUser && currentUser.session) {
          let loadingTimer

          loadingTimer = setTimeout(() => {
            // setIsCardLoading(true)
          }, 500)

          axios
            .post(baseUrl + finishTrack, requestBody, {
              headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                Accept: '*/*',
                session: currentUser.session,
              },
            })
            .then((res) => {
              if (res.data.message === '提交成功') {
                console.log('finishTrack', res.data)
                setCaseModalShow(false)
                setCaseClosedModalShow(false)
                extendCookie()
              }
            })
            .catch((e) => {
              console.log('finishTrack error', e)
              sendDiscordNotification(`finishTrack Error \n Error: ${e} `)
              alert('伺服器忙線中，請稍後再試')
            })
            .finally(() => {
              // setIsCardLoading(false)
              clearTimeout(loadingTimer)
            })
        }
      },
      onCancel: () => {},
    })
  }

  const RecordSchema = Yup.object().shape({
    finish_type: Yup.string().required('收案日期為必填項目'),
  })

  return (
    <>
      {' '}
      <Modal
        show={caseClosedModalShow}
        onHide={() => {
          setCaseClosedModalShow(false)
        }}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <h5 className="text-center text-danger my-3">
            ※請再次確保表單內容資料正確，送出後無法修改！※
          </h5>
          <div className="d-flex flex-column my-3 gap-2">
            <div>
              結案日期：<span className="h5">{today}</span>
            </div>
            <div>
              病人姓名：<span className="h5">{currentPatient.name}</span>
            </div>
          </div>
          <Formik
            initialValues={initialValues}
            // TODO yup schema
            validationSchema={RecordSchema}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              // Handle form submission, e.g., send data to an API
              console.log(values)
              handleSubmit(values)

              // Example: Setting a status message after submission
              // setStatus({ submitted: true });

              // Reset the form after successful submission
              // resetForm()

              // Set submitting to false after form is handled
              setSubmitting(false)
            }}
          >
            {({
              errors,
              touched,
              isSubmitting,
              status,
              setFieldValue,
              values,
            }) => (
              <Form>
                <div className="form-section">
                  <label>結案原因：</label>
                  <div
                    role="group"
                    aria-labelledby="finish_type-radio-group"
                    className="mt-2"
                  >
                    <label>
                      <Field type="radio" name="finish_type" value="0" />
                      個案經介入管理後，經個案管理評估已非代謝症候群患者
                    </label>
                    <label>
                      <Field type="radio" name="finish_type" value="1" />
                      病情變化無法繼續接受本計劃之照護者或屬「糖尿病及初期慢性腎臟病照護整合方案」中糖尿病相關條件收案者
                    </label>
                    <label>
                      <Field type="radio" name="finish_type" value="2" />
                      個案拒絕或失聯 ≧ 3 個月
                    </label>
                    <div>
                      <Field type="radio" name="finish_type" value="3" />
                      個案死亡
                    </div>
                    <label>
                      <Field type="radio" name="finish_type" value="4" />
                      收案個案已達一年且收案評估時未達標準值的管理項目，任一項接未有進步者
                    </label>
                  </div>
                  {renderErrorMessage(errors, touched, 'finish_type')}
                </div>
                <Modal.Footer className="my-3">
                  <Button
                    variant="outline-primary"
                    onClick={() => {
                      setCaseClosedModalShow(false)
                    }}
                  >
                    取消
                  </Button>
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    // onClick={() => {
                    //   setWarning({
                    //     show: true,
                    //     msg: '請再次確保表單內容資料正確，送出後無法修改！',
                    //     confirmMsg: '確認結案',
                    //     onConfirm: () => {
                    //       // TODO 等待 POST 成功後再秀成功訊息
                    //       setCaseModalShow(false)
                    //       setCaseClosedModalShow(false)
                    //     },
                    //     onCancel: () => {},
                    //   })
                    // }}
                  >
                    確認結案
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default MetabolicPlanClosed
